/**
 * @Author 22030124/xieyq
 * @Date 2023-11-20 15:09:22
 * @Description 加载组件 — 支持经典工作台远程 npm 组件 + 智擎工作台本地组件
 *
 * 分流逻辑：
 *   - blockCategoryName === '智擎' → 从本地 registry 查找组件（resolveLocalComponent）
 *   - npmUrl 为空（但 blockCategoryName 不是智擎）→ 也尝试本地 registry 兜底
 *   - 其他 → 走原有 hel-micro 远程 npm 加载逻辑
 */
import { preFetchLib } from 'hel-micro'
import { resolveLocalComponent } from '@/views/workbench-new/registry'

const SMART_CATEGORY_NAME = '智擎'

function isLocalCategory(item) {
  if (!item) return false
  // 方式 1：按分类名判断（推荐）
  if (item.blockCategoryName === SMART_CATEGORY_NAME) return true
  // 方式 2：npmUrl 为空时兜底走本地（兼容历史数据未填分类名的情况）
  if (!item.npmUrl && item.npmName) return true
  return false
}

export default {
  methods: {
    /**
     * 统一入口：分流到本地或远程（避免和 dynamic/index.vue 自身的 loadComponent 重名冲突）
     * @param {Object} componentItem 卡片配置对象（来自 element.data / fieldData）
     */
    async loadCardComponent(componentItem) {
      if (isLocalCategory(componentItem)) {
        return this.callLocalComponent(componentItem)
      }
      return this.callRemoteComponent(componentItem)
    },

    /**
     * 本地组件：从 registry 按 npmName 查找
     */
    async callLocalComponent(componentItem) {
      const name = componentItem.npmName
      const comp = resolveLocalComponent(name)
      if (!comp) {
        console.warn(
          `[loadComponent] 本地组件 "${name}" 未在智擎 registry 中注册。` +
            `已注册: ${JSON.stringify(require('@/views/workbench-new/registry').LOCAL_COMPONENT_NAMES)}`
        )
        return null
      }
      return comp
    },

    /**
     * 远程组件：走 hel-micro preFetchLib（原有逻辑）
     */
    async callRemoteComponent(componentItem) {
      const apiPrefix = 'https://unpkg.cosmoplat.com'
      const options = { apiPrefix }
      if (componentItem.npmVersion) {
        options.versionId = componentItem.npmVersion
      }
      try {
        const component = await preFetchLib(componentItem.npmUrl, options)
        return component ? component[componentItem.npmName || 'default'] : null
      } catch (err) {
        console.error('[loadComponent] 远程组件加载失败:', componentItem.npmUrl, err)
        return null
      }
    }
  }
}
